<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="用户">
        <Input
          style="width:200px"
          placeholder="请输入姓名"
          v-model="searchCondition.real_name"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item label="手机号">
        <Input
          style="width:200px"
          placeholder="请输入手机号"
          v-model="searchCondition.mobile"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>

      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/ask/ask/transferRecord"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        keyField="id"
        method="get"
      >
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "WithdrawRecord",
  data() {
    return {
      searchCondition: {
        real_name: "",
        mobile: ""
      },
      columns: [
        {
          title: "用户",
          key: "real_name",
          minWidth: 140,
          align: 'center'
        },
        {
          title: "手机号",
          key: "mobile",
          minWidth: 120,
          align: 'center'
        },
        {
          title: "提现金额",
          key: "amount",
          minWidth: 100,
          align: 'center'
        },
        {
          title: "账户余额",
          key: "balance",
          minWidth: 90,
          align: 'center'
        },
        {
          title: "提现时间",
          key: "create_at",
          minWidth: 150,
          align: 'center'
        }
      ],
    };
  },
  async created() {
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(row => {
          row.balance = '￥' + row.balance/100
          row.amount = '￥' + row.amount/100
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.real_name = "";
        this.searchCondition.mobile = "";
      } else {

      }
      this.$refs.grid.searchRefresh();
    }
  }
};
</script>
